import { Button } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { NoFound } from "@/icons"
import { Empty } from "antd"

import { QuickWinCard } from "@/molecules/QuickWinCard"
import { CardSkeleton } from "./CardSkeleton"

import styles from "./QuickWinsList.module.scss"

import type { QuickWinsListProps } from "./QuickWinsList.types"

export const QuickWinsList = ({
  quickWins,
  isLoading,
  onIgnore,
  onIssueClick,
  tab,
  hasFilters,
  onClearFilters,
  projectName
}: QuickWinsListProps) => {
  const { t } = useTranslation()

  if (isLoading) {
    return (
      <div className={styles.container}>
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
      </div>
    )
  }

  if (!quickWins.length) {
    const isFilterEmpty = tab === "suggested" && hasFilters
    const isAllReviewed = tab === "suggested" && !hasFilters

    if (isFilterEmpty) {
      return (
        <div className={styles.centered}>
          <div className={styles.emptyText}>
            <NoFound />
            <span>{t("quickWins.empty.noFilterResults")}</span>
            {onClearFilters && (
              <Button
                type="link"
                onClick={onClearFilters}
                className={styles.clearButton}
              >
                {t("quickWins.empty.clearSearch")}
              </Button>
            )}
          </div>
        </div>
      )
    }

    return (
      <div className={styles.centered}>
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <div className={styles.emptyText}>
              {isAllReviewed && (
                <>
                  <span>{t("quickWins.empty.allReviewed")}</span>
                  <span className={styles.emptySubtext}>
                    {t("quickWins.empty.allReviewedSubtext")}
                  </span>
                </>
              )}
              {tab === "ignored" && (
                <span>{t("quickWins.empty.noIgnored")}</span>
              )}
            </div>
          }
        />
      </div>
    )
  }

  return (
    <div className={styles.container}>
      {quickWins.map((quickWin) => (
        <QuickWinCard
          key={quickWin.id}
          quickWin={quickWin}
          projectName={projectName}
          onIgnore={onIgnore}
          onIssueClick={onIssueClick}
        />
      ))}
    </div>
  )
}
